import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {getPackageToModifySaga, modificationPackageSaga,} from "./modificationPackageSaga";

export default function* modificationPackageWatcher() {
  yield takeLatest(ActionsTypes.MODIFICATION_PACKAGE, modificationPackageSaga);
  yield takeLatest(ActionsTypes.GET_PACKAGE_TO_MODIFY, getPackageToModifySaga);
}
